import instance_api from "../../config/axiosConfig";
import {getOtSkills, getOvertimeCallsheet, addOTShift } from "../../constants/constants";

class OvertimeAPI {
    
    constructor(name) {
        this.name = name;
    }

     getOTSkillsData(station='') {
        return instance_api("GET", getOtSkills(station));
    }
    
    getCallsheet({ otGroup='', schedBidGroup='', volOtDate='', station='', shiftsReqs=[] }) {
        const data = {
            otGroup,
            schedBidGroup,
            volOtDate,
            station,
            shiftsReqs
        };
        return instance_api('POST', getOvertimeCallsheet(), data);
    }

    addOTShift(data) {
        return instance_api('POST', addOTShift(), data);
    }
}

export const {
    getOTSkillsData,
    getCallsheet,
    addOTShift: addOTShiftAPI
} = new OvertimeAPI("instance");
